var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient-new-appointment"},[_c('Breadcrumbs',{attrs:{"items":_vm.items}}),_c('v-container',{attrs:{"fluid":""}},[_c('NewAppointmentForm',{attrs:{"patients":[_vm.patient]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }